import { Grid } from '@chakra-ui/react';
import { format, parseISO } from 'date-fns';
import { useReviewCreationData } from 'reducers/reviewCreationSlice';

import { BulletList } from 'assets/assetsV1/iconComponents';

import {
  ExpandablePaper,
  ExpandablePaperBody,
  ExpandablePaperHeader,
} from 'uiToolkitV1/ExpandablePaper/ExpandablePaper';

import { useGetReviewTypeAndDetails } from '../../Hooks/dataHooks/reviewTypeAndDetailsDataHooks';
import { Detail, RenderDetails } from './RenderDetails';

export const ReviewDetails = () => {
  const { reviewCycleId } = useReviewCreationData();
  const { data: reviewCycleDetails = {}, isLoading } = useGetReviewTypeAndDetails({
    reviewCycleId,
  });
  const startDate = reviewCycleDetails.startDate ? format(parseISO(reviewCycleDetails.startDate), 'MMM dd, yyyy') : '';
  const endDate = reviewCycleDetails.endDate ? format(parseISO(reviewCycleDetails.endDate), 'MMM dd, yyyy') : '';

  const reviewCyclePeriod = startDate && endDate ? `${startDate} to ${endDate}` : '';

  const details: Detail[] = [
    {
      key: 'Review Cycle Period:',
      value: reviewCyclePeriod,
    },
    {
      key: 'Review Cycle Name:',
      value: reviewCycleDetails?.name,
    },
  ];

  return (
    <ExpandablePaper showLoader={isLoading}>
      <ExpandablePaperHeader title="Review Details" leftIconComponent={<BulletList boxSize="24px" color="icon.g2" />} />
      <ExpandablePaperBody>
        <Grid templateColumns="1fr 2fr" rowGap={8} columnGap={8} p="16px 8px 12px">
          <RenderDetails details={details} />
        </Grid>
      </ExpandablePaperBody>
    </ExpandablePaper>
  );
};
